import { Trans, useTranslation } from "react-i18next";

import what from '../../img/Stock/what.png';
import what_mob from '../../img/Stock/what_mob.png';

const WhatIsTradeStock = () => {
    const { t } = useTranslation();
    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px]">
               <div className="flex flex-col xl:flex-row justify-between gap-[20px] xl:gap-[30px]">
                    <img src={what} alt="" className="hidden xl:block"/>
                    <img src={what_mob} alt="" className="xl:hidden block"/>
                    <div>
                        <h4 className="md:text-[45px] font-[700] text-[28px] text-[#0C2780]">
                            {t('stock.10')}
                        </h4>
                        <p className="max-w-[495px] sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:mt-[15px] mt-[13px]">
                            {t('stock.11')}
                        </p>
                        <p className="max-w-[495px] sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:mt-[15px] mt-[13px]">
                            {t('stock.12')}
                        </p>
                    </div>
               </div>
            </div>
        </section>
    )
};

export default WhatIsTradeStock;
